<template>
  <div class="view">
    <Title title="クイズ"/>
    <QuizMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizMain from '@/components/QuizMain'

export default {
  components: {
    Title,
    QuizMain
  },

  created: function () {
    this.$store.dispatch('quiz/retrieveQuizzes', this.$route.params.id)
  }
}
</script>
